import { AvailabilitySlot } from '../availability-schedules.model';

/**
 * Parse hour (0-23) from a Healthie datetime string like "2025-12-02 15:00:00 -0800"
 */
export const parseHour = (rangeStr: string): number => {
  // Match HH:MM:SS in the datetime string
  const match = rangeStr.match(/(\d{2}):(\d{2}):\d{2}/);
  if (match) {
    return parseInt(match[1], 10);
  }
  return 0;
};

/**
 * Parse formatted time strings from range_start and range_end
 */
export const parseTimeFromRange = (
  rangeStart: string,
  rangeEnd: string,
): { startTime: string; endTime: string } => {
  const formatHour = (rangeStr: string): string => {
    const match = rangeStr.match(/(\d{2}):(\d{2}):\d{2}/);
    if (match) {
      const h = parseInt(match[1], 10);
      const m = match[2];
      const suffix = h >= 12 ? 'PM' : 'AM';
      const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
      return m === '00' ? `${h12} ${suffix}` : `${h12}:${m} ${suffix}`;
    }
    return '';
  };

  return {
    startTime: formatHour(rangeStart),
    endTime: formatHour(rangeEnd),
  };
};

/**
 * Check if a slot covers a given hour (0-23).
 * A slot from 09:00-11:00 covers hours 9 and 10 (not 11).
 */
export const slotCoversHour = (slot: AvailabilitySlot, hour: number): boolean => {
  const startHour = parseHour(slot.range_start);
  const endHour = parseHour(slot.range_end);
  return startHour <= hour && endHour > hour;
};

/**
 * Group slots by day_of_week (0-6)
 */
export const groupByDay = (
  slots: AvailabilitySlot[],
): Record<number, AvailabilitySlot[]> => {
  const grouped: Record<number, AvailabilitySlot[]> = {};
  for (const slot of slots) {
    const dow = slot.day_of_week;
    if (!grouped[dow]) {
      grouped[dow] = [];
    }
    grouped[dow].push(slot);
  }
  return grouped;
};

/**
 * Count distinct providers for a given day
 */
export const countProvidersForDay = (slots: AvailabilitySlot[]): number => {
  const uniqueProviders = new Set(slots.map((s) => s.user_id));
  return uniqueProviders.size;
};
